export type SdkPropTypes = 'string' | 'boolean' | 'number' | 'function';

export function SdkTypeCheck(type: SdkPropTypes, input: unknown) {
  if (typeof input !== type) {
    throw new TypeError(`[SDK] ${input} is not typeof ${type}`);
  }
}
